import PropTypes from 'prop-types';
// @mui
import { Box, Typography } from '@mui/material';

const COLOR_DARKORANGE = '#FC8D1F';
const COLOR_LIGHTGRAY = '#bebebe';

CauseDetails.propTypes = {
  resultTotal: PropTypes.number,
  causeName: PropTypes.string,
  cuaseDescription: PropTypes.string,
};

export default function CauseDetails({isLoading, resultTotal, causeName, cuaseDescription}) {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      {/* <Box sx={{ flexBasis: '50%', borderRight: `2px solid ${COLOR_LIGHTGRAY}` }}>
        <Typography sx={{ typography: 'h3', pb: 1, color: `${COLOR_DARKORANGE} !important` }}>{causeName}</Typography>
        <Typography sx={{ typography: 'body2' }}>{cuaseDescription}</Typography>
      </Box> */}
      <Box sx={{ flexBasis: '100%' }}>
        {isLoading ? (
          <Typography sx={{ typography: 'h3', pb: 1, color: `${COLOR_DARKORANGE} !important`, textAlign: 'center' }}>
            Loading...
          </Typography>
        ) : (
          <>
            <Typography sx={{ typography: 'h5', pb: 0, color: `${COLOR_DARKORANGE} !important`, textAlign: 'center' }}>
              {resultTotal}
            </Typography>
            <Typography sx={{ typography: 'body2', fontSize:"14px", textAlign: 'center' }}>Project Results</Typography>
          </> 
        )}
      </Box>
    </Box>
  );
}
